import {APIProvider, ControlPosition, Map as GoogleMaps, useMap} from "@vis.gl/react-google-maps";
import React, {useEffect} from "react";
import GarrisonTimelineMapContent from "./garrison-timeline-map-content.jsx";

const GarrisonTimelineMapResize = ({onReady}) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !globalThis.google?.maps) return;

    const resizeMap = () => globalThis.google.maps.event.trigger(map, "resize");
    const resizeObserver = new ResizeObserver(() => requestAnimationFrame(resizeMap));
    resizeObserver.observe(map.getDiv());
    const tilesListener = map.addListener("tilesloaded", () => {
      onReady?.();
      tilesListener.remove();
    });
    const timer = setTimeout(() => {
      resizeMap();
      const center = map.getCenter();

      if (center) map.setCenter(center);
      map.setZoom(map.getZoom());
    }, 400);

    return () => {
      clearTimeout(timer);
      resizeObserver.disconnect();
      tilesListener.remove();
    };
  }, [map, onReady]);

  return null;
};

const GarrisonTimelineMap = ({corporation, garrisonsList, timelineData, dispatches, elapsedSeconds, filter, snapshot, isPrint = false, onPrintReady, onActiveGarrisonsChange}) => {
  if(!corporation) return null;

  const latitude = parseFloat(corporation?.latitude) || 0;
  const longitude = parseFloat(corporation?.longitude) || 0;

  const position = {
    lat: latitude,
    lng: longitude
  }

  return(
    <div className={`relative box-border w-full p-2 ${isPrint ? "h-[650px]" : "h-full"}`}>
      <APIProvider apiKey={corporation?.maps_api_key ?? ""} language={"pt-BR"} libraries={["places"]}>
        <GoogleMaps
          mapId="a7e2dbd01b9a18afb82d00c6"
          defaultZoom={14}

          fullscreenControlOptions={{position: ControlPosition.BOTTOM_RIGHT}}
          defaultCenter={position}
          streetViewControl={false}
          mapTypeControl={true}
          scrollwheel={true}
          gestureHandling={'greedy'}
          style={{ height: "100%", width: "100%" }}
          mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
          disableDefaultUI={true}
        />
        {isPrint ? <GarrisonTimelineMapResize onReady={onPrintReady}/> : null}
        <GarrisonTimelineMapContent
          garrisonsList={garrisonsList}
          timelineData={timelineData}
          dispatches={dispatches}
          elapsedSeconds={elapsedSeconds}
          filter={filter}
          snapshot={snapshot}
          onActiveGarrisonsChange={onActiveGarrisonsChange}
        />
      </APIProvider>
    </div>
  )
}

export default GarrisonTimelineMap;
